import { render } from "./ErrorContent.vue?vue&type=template&id=42a7d4e5"
const script = {}

import exportComponent from "/Users/gisselareyes/Documents/Github/gisse-la/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__